const internationalCodes = country => {
  switch (country) {
    case 'br':
      return '55'
    case 'us':
    default:
      return '1'
  }
}

const toInternationalFormat = phone => {
  return `+${phone.replace(/\D/g, '')}`
}

const formatPhone = (country, phone) => {
  const withInternationalCode = `${internationalCodes(country)}${phone}`
  return toInternationalFormat(withInternationalCode)
}

export default formatPhone
